<template>
  <div>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          병원명 <span class="asterisk">*</span>
        </v-list-item-title>
        <v-text-field
          solo
          required
          ref="refHospital"
          placeholder="병원명을 입력해 주세요"
          :height="formHeight"
          :rules="[requiredRuleByItem('병원명'), lessCounterRuleByLength(10)]"
          v-model="userData.hospital"
          append-icon="mdi-check"
        />
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          병원주소 <span class="asterisk">*</span>
        </v-list-item-title>
        <v-text-field
          solo
          required
          readonly
          ref="refHospitalAddr"
          placeholder="주소를 입력해 주세요"
          :height="formHeight"
          :rules="[requiredRuleByItem('병원주소')]"
          v-model="userData.hospitalAddr"
        >
          <!-- 인풋 안쪽 끝에 항상 버튼 -->
          <template #append>
            <v-btn
              small
              rounded
              class="btn-text-white"
              color="mainColorDark"
              @click.stop="openPostcode"
            >
              주소찾기
            </v-btn>
          </template>
        </v-text-field>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          진료과 <span class="asterisk">*</span>
        </v-list-item-title>
        <v-combobox
          solo
          required
          ref="refMajors"
          placeholder="진료과를 선택하거나 입력해 주세요"
          :height="formHeight"
          :rules="[requiredRuleByItem('진료과')]"
          v-model="userData.majors"
          :items="majorsItems"
          append-icon="mdi-menu-down"
          hide-no-data
          hide-selected
          :returnObject="false"
        />
        <!-- '기타'일 경우 직접 입력창 표시 -->
        <v-text-field
          v-if="userData.majors === '기타'"
          v-model="userData.majorsEtc"
          placeholder="진료과 직접 입력"
          :rules="[requiredRuleByItem('진료과(기타)'), lessCounterRuleByLength(10)]"
          solo
          class="mt-2"
        />
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script>
import { requiredRuleByItem, lessCounterRuleByLength } from "@/utils/rules.js";

export default {
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formHeight: 52,
      requiredRuleByItem,
      lessCounterRuleByLength,
      majorsItems: [
        '산부인과(OBGY)',
        '내과(IM)',
        '일반의원(GP)',
        '기타',
      ],
      showPostcode: true,
    };
  },
  methods: {
    openPostcode() {
      new window.daum.Postcode({
        oncomplete: (data) => {
          this.userData.hospitalAddr = data.roadAddress;

          // 주소 입력 후 인풋에 포커스 유지
          this.$nextTick(() => {
            const input = this.$refs.refHospitalAddr?.$el.querySelector('input');
            if (input) {
              input.focus();
              input.setSelectionRange(input.value.length, input.value.length);
            }
          });
        },
      }).open();
    },
  },
};
</script>
